import React, { useEffect, useRef, useState } from "react";

const LazyLoadedImage = ({ src, alt, className }) => {
  const imgRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    });

    observer.observe(imgRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <img
      className={className ? className : ""}
      ref={imgRef}
      src={isVisible ? src : ""}
      alt={alt}
    />
  );
};

export default LazyLoadedImage;
